import { Stack, Skeleton, Box } from "@mui/material";
import React from "react";

const ShareLinkModalSkeleton = () => (
  <Stack
    sx={{
      p: { xs: "2.4rem", sm: "3.2rem" },
      maxWidth: "50rem",
      width: "100%",
      maxHeight: "22rem",
      gap: "3.6rem",
      borderRadius: "1rem",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      backgroundColor: "background.default",
      border: "1px solid",
      borderColor: "grey.100"
    }}
    data-testid="share-link-modal-skeleton"
  >
    <Stack gap="1.6rem" width="100%">
      <Skeleton variant="text" width={200} height={32} />
      <Skeleton variant="text" width={250} height={20} />
    </Stack>

    <Box
      sx={{
        display: "flex",
        gap: "0.8rem",
        alignItems: "center",
        justifyContent: "space-between",
        border: "1px solid",
        borderColor: "grey.100",
        borderRadius: "1rem",
        height: "56px",
        width: "100%",
        padding: "1rem 1.4rem"
      }}
    >
      <Skeleton variant="text" width="60%" height={20} />
      <Skeleton variant="rounded" width={110} height={40} sx={{ borderRadius: "0.4rem" }} />
    </Box>

    <Skeleton
      variant="circular"
      width={40}
      height={40}
      sx={{ position: "absolute", top: "1.6rem", right: "1.6rem" }}
    />
  </Stack>
);

export default ShareLinkModalSkeleton;
